import type { SVGProps } from 'react';

export const ViewStreamIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M18.333 2.6666H5.66635C3.64369 2.6666 1.99969 4.31059 1.99969 6.33325V14.9999C1.99969 17.0226 3.64369 18.6666 5.66635 18.6666H18.333C20.3556 18.6666 21.9996 17.0226 21.9996 14.9999V6.33325C21.9996 4.31059 20.3556 2.6666 18.333 2.6666ZM16.921 11.8546C16.201 12.7812 14.605 14.3332 11.9997 14.3332C9.39434 14.3332 7.79834 12.7812 7.07834 11.8559C6.52768 11.1452 6.52768 10.1906 7.07834 9.47991C7.79834 8.55325 9.39434 7.00125 11.9997 7.00125C14.605 7.00125 16.201 8.55325 16.921 9.47858C17.473 10.1906 17.473 11.1452 16.921 11.8559V11.8546ZM17.6663 22.6665H6.33301C5.78101 22.6665 5.33301 22.2185 5.33301 21.6666C5.33301 21.1146 5.78101 20.6666 6.33301 20.6666H17.6663C18.2183 20.6666 18.6663 21.1146 18.6663 21.6666C18.6663 22.2185 18.2183 22.6665 17.6663 22.6665ZM13.9997 10.6666C13.9997 11.7711 13.1042 12.6666 11.9997 12.6666C10.8951 12.6666 9.99967 11.7711 9.99967 10.6666C9.99967 9.56201 10.8951 8.66658 11.9997 8.66658C13.1042 8.66658 13.9997 9.56201 13.9997 10.6666Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
